import Red from '@material-ui/core/colors/red'

const NoRowsAvailable = ({ menu }) => {
  return (
    <p style={{ color: Red[500] }}>Tidak ada entri data {menu}</p>
  )
}

export default NoRowsAvailable